/* eslint-disable react/require-default-props */
import React, { useState, useEffect, useCallback } from 'react'
import { formatDecimalsHelper } from '@qirapagos/lib/utils/common'
import { LocalStorage } from 'constants/localStorage'
import { moneySymbol } from '@qirapagos/lib/constants/common'
import {
  Container,
  Title,
  Subtitle,
  AmountContainer,
  BalanceWithNoDecimals,
  BalanceDecimals,
  HeaderContainer,
  InvestmentButton,
  BottomContainer,
  Performance,
  getPerformanceBoxStyle,
  getTriangleStyle,
  PerformanceValue,
  BalanceHoldingErrorText,
  EyeButton
} from './style'
import EyeShowPassword from '@qirapagos/lib/assets/svg/EyeShowPassword'
import EyeSlashPassword from '@qirapagos/lib/assets/svg/EyeSlashPassword'

interface Props {
  title: string
  subtitle?: string
  width?: string | number
  height?: string | number
  action?: string
  showEyeButton?: boolean
  lastPerformance?: any
  amount: string
  balanceHoldingError?: boolean
  onPressButton?: () => void
  disabledAction?: boolean
}

const BoxInvestment: React.FC<Props> = ({
  title,
  subtitle,
  width,
  height,
  action,
  showEyeButton = false,
  lastPerformance,
  amount,
  balanceHoldingError,
  onPressButton,
  disabledAction = false
}) => {
  const [showPassword, setShowPassword] = useState(
    localStorage.getItem(LocalStorage.SHOW_PASSWORD) === 'true'
  )
  const amountString = String(amount)
  const { balanceWithNoDecimals, decimals } = formatDecimalsHelper(amountString)

  const showAmount = useCallback(() => {
    const newValue = !showPassword
    setShowPassword(newValue)
    localStorage.setItem(LocalStorage.SHOW_PASSWORD, String(newValue))

    window.dispatchEvent(new CustomEvent('password-visibility-changed'))
  }, [showPassword])

  useEffect(() => {
    const handler = () => {
      setShowPassword(localStorage.getItem(LocalStorage.SHOW_PASSWORD) === 'true')
    }

    window.addEventListener('password-visibility-changed', handler)

    return () =>
      window.removeEventListener('password-visibility-changed', handler)
  }, [])

  const haveIcon = lastPerformance !== 0 && lastPerformance !== undefined

  const renderAmount = (
    <>
      <BalanceWithNoDecimals>
        {moneySymbol}
        {balanceWithNoDecimals}
      </BalanceWithNoDecimals>
      <BalanceDecimals>{decimals}</BalanceDecimals>
    </>
  )

  return (
    <Container style={{ width, height }}>
      <HeaderContainer>
        <Title>{title}</Title>
        {lastPerformance !== undefined && !balanceHoldingError && (
          <Performance style={getPerformanceBoxStyle(lastPerformance)}>
            {haveIcon && <p style={getTriangleStyle(lastPerformance < 0)} />}
            <PerformanceValue>{lastPerformance}</PerformanceValue>
          </Performance>
        )}
      </HeaderContainer>
      <Subtitle>{subtitle}</Subtitle>
      <AmountContainer>
        {balanceHoldingError
          ? (
            <BalanceHoldingErrorText>
              Tu saldo se mostrará aquí cuando esté disponible.
            </BalanceHoldingErrorText>
            )
          : showPassword
            ? (
                renderAmount
              )
            : (
              <BalanceWithNoDecimals>**********</BalanceWithNoDecimals>
              )}
        {(showEyeButton && !balanceHoldingError) && (
          <EyeButton onClick={showAmount}>
            {showPassword ? <EyeShowPassword /> : <EyeSlashPassword />}
          </EyeButton>
        )}
      </AmountContainer>
      {action && (
        <BottomContainer>
          <InvestmentButton
            $disabled={disabledAction || balanceHoldingError}
            onClick={!(disabledAction || balanceHoldingError) ? onPressButton : undefined}
          >
            {action}
          </InvestmentButton>
        </BottomContainer>
      )}
    </Container>
  )
}

export default BoxInvestment
